import script from "./NotFoundView.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotFoundView.vue?vue&type=script&setup=true&lang=ts"

import "./NotFoundView.vue?vue&type=style&index=0&id=75b873b0&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\user\\Documents\\Code\\VSProjects\\modboxProject\\modbox\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75b873b0"]])

export default __exports__